var _excluded = ["icon", "isDisabled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Icon } from '../../../foundations/Icon';
import { forwardRef } from '../../../utils';
import { useStyleConfig } from '../../../utils/use-style-config';
import { Box } from '../../internal';
import { jsx as _jsx } from "react/jsx-runtime";
export var FloatingButton = forwardRef((props, ref) => {
  var {
    icon,
    isDisabled
  } = props,
      rest = _objectWithoutProperties(props, _excluded);

  var styles = useStyleConfig('FloatingButton');
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    "data-component": "FloatingButton",
    as: "button",
    type: "button"
  }, rest), {}, {
    // WE are using `disabled` prop for testing, we want the users to be able to use `toBeDisabled` on floatingButton in unit tests.
    // ts-ignore is used due to `type` issues with `<Box/>`.
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    disabled: isDisabled,
    __css: styles,
    ref: ref,
    children: /*#__PURE__*/_jsx(Icon, {
      type: icon,
      size: "large",
      color: "inherit"
    })
  }));
});
FloatingButton.displayName = 'FloatingButton';
//# sourceMappingURL=FloatingButton.js.map